<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <h3 style="margin: 20px 0">{{ theSession.name }}</h3>
        <div style="border: 3px solid #f3f3f3; margin-bottom: 15px"></div>
        <div class="stepBox">
          <div class="tabBox">
            <el-steps
              :active="busactive"
              align-center
              class="stepsItem"
              v-if="stepRes != 0"
            >
              <el-step
                v-for="(item, index) in stepsList"
                :class="index <= stepRes.data.progess - 1 ? 'changecolor' : ''"
                :key="index"
                :title="item.title"
                @click.native="changeSteps(index)"
              ></el-step>
            </el-steps>
          </div>
        </div>
        <!--   资料填写 审核 -->
        <template v-if="busactive == 0">
          <data-review
            :key="dataReviewKey"
            v-if="
              (buttonGroupStatus.audit_status == 0 ||
                buttonGroupStatus.audit_status == -1 ||
                buttonGroupStatus.audit_status == 10) &&
              buttonGroupStatus.showComponent
            "
            :status="buttonGroupStatus.audit_status"
          ></data-review>
          <to-examine
            v-if="
              (buttonGroupStatus.audit_status == 1 ||
                buttonGroupStatus.audit_status == 2 ||
                buttonGroupStatus.audit_status == 9) &&
              buttonGroupStatus.showComponent
            "
            :to_examine_form="buttonGroupStatus"
          ></to-examine>
        </template>
        <!--   定金确认 审核 -->
        <template v-if="busactive == 1">
          <deposit></deposit>
        </template>
        <!--   选场意愿 审核 -->
        <template v-if="busactive == 2">
          <selection-intention></selection-intention>
        </template>
        <!--   合同确认 审核 -->
        <template v-if="busactive == 3">
          <contractConfirmation></contractConfirmation>
        </template>
        <!--   尾款确认  审核 -->
        <template v-if="busactive == 4">
          <balancePayment></balancePayment>
        </template>
        <!--   完成 详情-->
        <template v-if="busactive == 5">
          <!--<<<<<<< HEAD-->
          <!--          <data-review :key="dataReviewKey"-->
          <!--                       v-if="buttonGroupStatus.audit_status == 2 && buttonGroupStatus.showComponent"-->
          <!--                       :status="buttonGroupStatus.audit_status"></data-review>-->
          <!--=======-->
          <div class="top_text">
            本季报名已完成，组委会将把各类服务文件陆续上传至下载中心，请您及时接收及下载，确保各项工作顺利推进
          </div>
          <data-review
            :key="dataReviewKey"
            v-if="
              buttonGroupStatus.audit_status == 2 &&
              buttonGroupStatus.showComponent
            "
            :step="this.busactive"
            :status="buttonGroupStatus.audit_status"
          ></data-review>
        </template>
      </div>
    </div>
    <div class="mask" v-if="isUploading">
      <i class="el-icon-loading"></i>
      <p>正在上传中</p>
    </div>
  </div>
</template>

<script>
import { enterprise } from "@/utils/individualForm"; //动态表单切换
import {
  MemberBrandLists,
  MembersDetail,
  MembersEdit,
  MembersRevoke,
  MembersSubmit,
  getStepAndState,
  getDataReview,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import dataReview from "./dataReview/dataReview.vue"; // 资料审核
import deposit from "./deposit.vue";
import SelectionIntention from "@/views/selectionIntention.vue"; // 订金确认
import contractConfirmation from "@/views/contractConfirmation.vue"; // 合同
import balancePayment from "@/views/balancePayment.vue"; // 尾款
import toExamine from "@/views/toExamine.vue"; // 审核状态页
export default {
  components: {
    SelectionIntention,
    top,
    dataReview,
    deposit,
    contractConfirmation,
    balancePayment,
    toExamine,
  },
  name: "busInformation",
  provide() {
    return {
      uploadCallback: this.handleShowMask,
    };
  },
  data() {
    return {
      countdown: 5, //计时器
      countdown_show: true, //计时器
      headers: {
        token: localStorage.getItem("token"),
      },
      ccompanyList: JSON.parse(localStorage.getItem("ccompanyList")),
      SheetData: {},
      form_data: {},
      typeList: [
        {
          id: "1",
          name: "个人委员会",
        },
        {
          id: "2",
          name: "单位委员会",
        },
      ],
      MemberLevelList: [],
      isigned: "",
      checked: true,
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      radio: 3,
      text: "您的资料正在审核中",
      status: 1,
      committee_text_show: false, //富文本弹窗
      brandTitle: "", //品牌弹窗名称
      brandForm: {
        //品牌表单数据
        id: "", //品牌id
        ownership: "", //所属类型 1:个人会员，2:单位会员
        user_long_id: "", //所关联的用户长ID
        brand_name: "", //品牌名称
        website: "", //品牌官网
        brand_type: "", //品牌类别
        registration_time: "", //注册时间
        registration_address: "", //注册地
        trademark: [], //商标注册证或代理授权
        category: "", //品类
        offline_store: "", //线上分布/线上店铺
        online_store: "", //入驻电商平台
        SKU: "", //年sku数
        product_price: "", //产品及价位
        honors: "", //奖项及荣誉
      },
      brandFormRules: {
        //品牌表单验证
      },
      active: 10,
      busactive: 0,
      page_no: 1,
      page_size: 10,
      total: 100,
      stepsList: [
        { title: "资料审核" },
        { title: "订金确认" },
        { title: "选场意愿" },
        { title: "合同确认" },
        { title: "尾款确认" },
        { title: "完成" },
      ],
      tabList: [],
      informationForm: {
        //登记
        audit_status: 4,
        type: "",
        level_long_id: "",
        committee_id: "",
        promise_file: "",
      },
      informationRules: {
        type: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        committee_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        level_long_id: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      }, //基本信息表单验证

      activeName: "basic",
      loading: false,
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      mark: "",
      result: [],
      // 品牌申报
      buttonGroupStatus: {
        audit_status: null, // 初始值  -1为预览，10为重新填报，后台没有这两个值，前端自己配置
        component: "",
        showComponent: false,
      },
      isUploading: false,
      declareId: -1,
      stepRes: 0,
      theSession: JSON.parse(localStorage.getItem("theSession")),
      dataReviewKey: 0, // 步骤1 点到 步骤6，因为加载同一个dataReview组件，vue因为性能问题不会做组件切换，所以无法切换可改和不可改状态，加一个:key来避免此问题
    };
  },
  mounted() {
    this.init();
  },
  created() {
    this.declareId = JSON.parse(localStorage.getItem("theSession")).id;
    this.initStep();
  },
  watch: {
    // busactive(index) {
    //   if (index == 2) {
    //     this.countdown_show = true
    //     this.timer()
    //   }
    // }
  },
  methods: {
    async initStep() {
      this.stepRes = await getStepAndState(
        "declare_items_id=" + this.declareId
      );
      console.log(this.stepRes.data.progess);
      this.busactive = this.stepRes.data.progess - 1;
      if (this.busactive == 0) {
        const statusRes = await getDataReview(
          "declare_items_id=" + this.declareId
        );
        if (
          Object.keys(statusRes.data).length !== 0 &&
          statusRes.information_examine != 0
        ) {
          this.buttonGroupStatus = {
            audit_status: statusRes.data.information_examine,
            component: "dataReview",
            showComponent: true,
          };
        } else {
          this.buttonGroupStatus = {
            audit_status: 0,
            component: "dataReview",
            showComponent: true,
          };
        }
      } else if (this.busactive == 5) {
        this.buttonGroupStatus = {
          audit_status: 2,
          component: "dataReview",
          showComponent: true,
        };
      }
    },
    handleShowMask(state) {
      this.isUploading = state;
    },
    async init() {},

    to_next() {
      this.busactive = this.busactive + 1;
    },

    //   改变步骤条
    async changeSteps(index) {
      if (Number(index) + 1 <= Number(this.stepRes.data.progess)) {
        this.busactive = index;
        if (index == 0) {
          const statusRes = await getDataReview(
            "declare_items_id=" + this.declareId
          );
          this.dataReviewKey++;
          if (
            Object.keys(statusRes.data).length !== 0 &&
            statusRes.information_examine != 0
          ) {
            this.buttonGroupStatus = {
              audit_status: statusRes.data.information_examine,
              component: "dataReview",
              showComponent: true,
            };
          } else {
            this.buttonGroupStatus = {
              audit_status: 0,
              component: "dataReview",
              showComponent: true,
            };
          }
        } else if (index == 5) {
          this.dataReviewKey++;
          this.buttonGroupStatus = {
            audit_status: 2,
            component: "dataReview",
            showComponent: true,
          };
        }
      }
    },

    // 返回
    goBack() {
      this.$router.push({
        name: "home",
        params: {
          menu: 2,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top_text {
  padding: 10px;
  color: #e40080;
  background: rgba(228, 0, 128, 0.05);
  border-radius: 4px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  font-style: normal;
}

.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }

  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

/deep/ .el-dialog__body {
  //height: 600px !important;
  overflow: auto;
}

.unitTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7f8fa4;
  margin: 30px 0 10px;
}

.statusBox {
  width: 749px;
  height: 100px;
  background: rgba(250, 173, 20, 0.1);
  border-radius: 18px;
  font-family: PingFangSC, PingFang SC;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.statusBox_text {
  width: 520px;
  line-height: 24px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.status1 {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}

.status2 {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}

.status3 {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}

.changecolor {
  cursor: pointer;

  /deep/ .el-step__line {
    background-color: rgba(228, 0, 128, 0.4);
  }

  /deep/ .el-step__head.is-wait {
    border-color: rgba(228, 0, 128, 0.4);
    color: rgba(228, 0, 128, 0.4);
  }

  /deep/ .el-step__title.is-wait {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(228, 0, 128, 0.4);
  }
}

//   步骤条样式修改
.stepBox {
  //width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 0 30px;
  box-sizing: border-box;

  .go-back {
    position: absolute;
    left: 0;
    top: 0;
  }

  /deep/ .el-step.is-center .el-step__line {
    left: 68%;
    right: -22%;
  }

  /deep/ .el-step__icon {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }

  ///deep/ .el-step__head.is-wait {
  //  color: #C7C7CC;
  //  border-color: #C7C7CC;
  //}

  /deep/ .el-step__head.is-process {
    border-color: #e40080;
    color: #e40080;

    .el-step__line {
      background: #e40080;
    }
  }

  /deep/ .el-step__head.is-finish {
    border-color: rgba(228, 0, 128, 0.4);
    color: rgba(228, 0, 128, 0.4);

    .el-step__line {
      background: rgba(228, 0, 128, 0.4);
    }
  }

  /deep/ .el-step__title.is-finish {
    color: rgba(228, 0, 128, 0.4);
    font-size: 12px;
  }

  ///deep/ .el-step__title.is-wait {
  //  font-family: PingFangSC, PingFang SC;
  //  font-weight: 400;
  //  font-size: 12px;
  //  color: #8E8E93;
  //}

  /deep/ .el-step__title.is-process {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #e40080;
  }
}

//   步骤条盒子
.stepsItem {
  width: 692px !important;
}

//   基本信息表单盒子
.informationFormBox {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .bus-informationForm {
    width: 560px !important;

    /deep/ .el-select {
      width: 400px;
    }
  }

  .next {
    margin-top: 190px;
  }
}

.apply-phone {
  /deep/ .el-input__inner {
    width: 400px;
    height: 36px;
    border: 1px solid #cad2dd;
  }
}

.formBox {
  //height: 650px;
  //overflow: auto;
}

.footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.QR_box {
  text-align: center;
}

.QR_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}

.checkboxBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 94px;
}

/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #eee;
}

/deep/ .el-tabs__header {
  //padding: 20px 0;
  margin: 0;
}

.tableBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.searchBtnBox {
  margin-bottom: 20px;
}

.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.selitem {
  width: 100%;
}

// 完成缴费
.completePaymentBox {
  width: 880px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
  margin: 20px auto 0;
  padding: 30px 20px 66px;
  box-sizing: border-box;

  .completePaymentTips {
    width: 252px;
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1d1d1d;
    line-height: 20px;
    margin-bottom: 30px;
  }

  .completePaymentLine {
    width: 100%;
    height: 1px;
    background: #eeeeee;
  }

  .payInfoBox {
    display: flex;
    align-items: center;
    margin: 13px 0;

    .left {
      span {
        display: inline-block;
      }

      span:nth-child(1) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #1d1d1d;
      }

      span:nth-child(2) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #ff4d4f;
      }
    }

    .right {
      margin-left: 185px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #555555;

      .rightInfo {
        display: flex;
        margin: 10px 0;

        .rightItem {
          margin-right: 70px;
        }
      }
    }
  }

  .paytitle {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #1d1d1d;
    margin-top: 10px;
  }

  .upload-demo {
    margin-left: 26px;
    display: flex;
    margin-top: 17px;
  }

  /deep/ .el-upload-list__item {
    margin-top: 0;
  }

  .changepay {
    display: flex;
    align-items: flex-start;
  }

  .wyjf {
    margin-top: 39px;
  }

  .radioItem {
    display: inline-block;
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #eeeeee;
    margin-top: 9px;

    .radioIcon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 3px;
    }
  }

  .codeBox {
    display: flex;
    width: 345px;
    height: 116px;
    padding: 7px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #dedede;
    margin-top: 20px;

    .code {
      width: 102px;
      height: 102px;
    }

    .codeinfo {
      margin-left: 10px;

      .info1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-top: 10px;
      }

      .info2 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #ff4d4f;
        margin-top: 10px;
      }

      .info3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-top: 16px;
      }
    }
  }
}

.upload-btn {
  width: 61px;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
}

.search-btn:hover {
  background: #e40080;
}

.search-btn:active {
  background: #e40080;
}

.content {
  padding-bottom: 40px;

  .main-title {
    margin-top: 40px;
    margin-bottom: 35px;
  }
}

.personageCommitment {
  padding-top: 30px;
  width: 100%;
  height: 490px;
  background: #f2f6fb;
}

.unitCommitment {
  width: 100%;
  height: 490px;
}

.downloadBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 383px;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 9px;
  border: 1px solid #cad2dd;
}

.downloadLeft {
  display: flex;
}

.downloadIcon {
  cursor: pointer;
  width: 60px;
  height: 26px;
  background: #e40080;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 10px;
  color: #ffffff;
  border: none;
}

.pdfIcon {
  width: 70px;
  height: 70px;
  border-radius: 6px;
}

.unitRight {
  margin-left: 20px;

  .unittitle {
    line-height: 68px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #2c2c2e;
  }

  .unittimes {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin: 15px 0;
  }

  .unitnum {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
  }
}

.poster {
  width: 100%;
  display: block;
  margin-top: 50px;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999999;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #e40080;
  font-size: 32px;
  font-weight: 700;

  p {
    font-size: 20px;
    font-weight: 500;
    margin-top: 16px;
  }
}
</style>
